import RuleBuilderConditional from '@cox/core-ui8/dist/RuleBuilderConditional'

import ComponentTypeRenderer from '../../config/component-type-renderer'
import withAEM from '../../hoc/withAEM'

const ReactRuleBuilderConditional = (props: any): JSX.Element => {
  const ReactRuleBuilderConditionalWithAEM = withAEM(RuleBuilderConditional)
  return (
    <ReactRuleBuilderConditionalWithAEM
      {...props}
      componentTypeRenderer={ComponentTypeRenderer}
      compName={'React Rule Builder Conditional'}
      showErrorBanner={true}
    />
  )
}

export default ReactRuleBuilderConditional
